export default [
  {
    path: '/payroll',
    name: 'payroll',
    component: () => import('@/views/payroll/Payroll.vue'),
    meta: {
      title: 'payroll ',
      requiresAuth: true,
      action: 'browes',
      resource: 'payroll',
      pageTitle: 'payroll',
      breadcrumb: [
        {
          text: 'payroll',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payroll/:id',
    name: 'payroll-details',
    component: () => import('@/views/payroll/PayrollDetails.vue'),
    meta: {
      title: 'Payroll Details ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Payroll Details',
      pageTitle: 'Payroll Details',
      breadcrumb: [
        {
          text: 'payroll',
          to: '/payroll',
        },
        {
          text: 'Payroll Details',
          active: true,
        },
      ],
    },
  },
]
